import { render, staticRenderFns } from "./taskList.vue?vue&type=template&id=5b81c426&scoped=true&"
import script from "./taskList.vue?vue&type=script&lang=ts&"
export * from "./taskList.vue?vue&type=script&lang=ts&"
import style0 from "./taskList.vue?vue&type=style&index=0&id=5b81c426&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b81c426",
  null
  
)

export default component.exports